import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AnnouncementIcon from "../global-components/CommonIcons/AnnouncementIcon";
import { getAnnouncementMsg } from "../../services/announcement-msg";
import Marquee from "react-fast-marquee";

const MsHeader = () => {
  const { channelUrl } = useSelector(
    (state) => state.partnerChannelNameSlice.marutiUserDetails
  );

  const [msg, setMsg] = useState([]);
  useEffect(() => {
    getAnnouncementMsg().then((data) => {
      setMsg(data);
    });
  }, []);

  return (
    <header>
      <div className="flex justify-between  pl-6 pr-6 pt-1 pb-1 border h-[60px] shadow-md ">
        <div className="flex items-center gap-3">
          <img
            src="/assets/hdfc-ergo-logo.webp"
            alt="hdfcErgo-logo"
            className="w-[60px] h-[40px]"
          />
          <h1 className="font-bold">KYC</h1>
          {msg[0] && msg[0]?.data && msg[0].data[0]?.message && <Marquee
              scrollamount="10"
              style={{ width: "80vw", fontWeight: "600" }}
              className="lg:text-[0.80rem] font-medium bottom-0 right-0 text-[0.70rem] mb-2 text-gray-600"
            >
              <div className="flex items-center">
                {msg[0]?.data?.map((anMsg) => {
                  return (
                    <>
                      <AnnouncementIcon />
                      &emsp;
                      <b className="text-red-500">{anMsg?.prefix}:</b>&emsp;
                      {anMsg?.message}&emsp;
                    </>
                  );
                })}
              </div>
            </Marquee>}
        </div>
        {channelUrl === "maruti" ? (
          <div className="flex items-center">
            <img
              src="/assets/ms_logo.png"
              alt="MS-logo"
              className="w-[100px] h-[20px] md:w-[182px] md:h-[30px]"
            />
          </div>
        ) : null}
      </div>
    </header>
  );
};

export default MsHeader;
